/**
 * Oprávnění modulu Reservations (zrcadlí backend `ReservationsPermissions`).
 * `read` = zobrazení agendy obchodních případů (menu, gate), `edit` = úpravy.
 */
export const RESERVATIONS_BUSINESS_CASES = 'reservations.business-cases';
